import $ from 'jquery';
import _ from 'lodash';
import {ScrollLock} from '../utils/scrollLock'


var defaultConfig = {
    animationDuration: 200,
    maxWidth: 500,
    menuTopBuffer: 0,
    desktopBreakpoint: 768,
    dismissOnResizeToDesktop: false,
    dismissOnResizeToMobile: false
};

export class SidePanel {

    /**
     *
     */
    constructor(config){

        this.config = _.defaults(config || {}, defaultConfig);

        /**
         *
         * @type {boolean}
         */
        this.isOpen = false;

        /**
         *
         * @type {boolean}
         */
        this.animationInProgress = false;

        /**
         *
         * @type {jQuery}
         */
        this.$root = $(document.createElement('div'))
            .addClass('ar-sidepanel')
            .css('display', 'none');

        /**
         *
         * @type {jQuery}
         */
        this.$header = $('.ar-header');

        this.init();
    }

    /**
     *
     */
    init(){
        this.initEvents();
        this.initStage();
    }


    /**
     * Init event listeners
     */
    initEvents(){
        $(window).on('resize', _.throttle(this.onWindowResize.bind(this), 150));
    }

    /**
     * Build UI elements needed to render menu
     */
    initStage(){
        this.$root.appendTo(document.body);
    }


    /**
     * 
     */
    updateGeometry(){
        if(this.isOpen) {
            var navClientRect = this.$header[0].getBoundingClientRect();
            var rootEl = this.$root[0];
            rootEl.style['paddingTop'] = navClientRect.height + 'px';
        }
    }


    /**
     *
     * @returns {Promise}
     * @private
     */
    _showPanel(){
        return this._animateInContainer()
            .then(()=> {
                ScrollLock.lock();
                this.isOpen = true
            });
    }

    /**
     *
     * @returns {Promise}
     * @private
     */
    _hidePanel(){
        return this._animateOutContainer().then(()=> {
            ScrollLock.release();
            this.isOpen = false
        });
    }


    /**
     *
     * @returns {Promise}
     * @private
     */
    _animateInContainer(){
        var rootEl, navClientRect;

        this.animationInProgress = true;

        rootEl = this.$root[0];
        navClientRect = this.$header[0].getBoundingClientRect();


        //Set last position
        rootEl.style['position'] = 'fixed';
        //Add a buffer to top edge so that on resize we dont see a gap between top bar and side nav
        rootEl.style['top'] = '0px';
        rootEl.style['paddingTop'] = navClientRect.height + 'px';
        rootEl.style['right'] = 0;
        rootEl.style['left'] = 'auto';
        rootEl.style['width'] = navClientRect.width + 'px';
        rootEl.style['bottom'] = 0;
        rootEl.style['display'] = 'block';
        rootEl.style['maxWidth'] = this.config.maxWidth + 'px';


        //Invert position
        rootEl.style['transform'] = `translate3d(${navClientRect.width}px,0,0)`;
        rootEl.style['-webkit-transform'] = `translate3d(${navClientRect.width}px,0,0)`;

        //Force sync layout
        var rootClientRect = rootEl.getBoundingClientRect();

        return new Promise((resolve, reject) => {
            requestAnimationFrame(() => {

                //Switch on animation
                this.$root.addClass('animate-on-transforms');

                //Play animation
                rootEl.style['transform'] = `translate3d(0,0,0)`;
                rootEl.style['-webkit-transform'] = `translate3d(0,0,0)`;


                setTimeout(()=> {
                    this.$root.removeClass('animate-on-transforms');

                    this.animationInProgress = false;

                    resolve();
                }, this.config.animationDuration)
            });
        });
    }

    /**
     *
     * @returns {Promise}
     * @private
     */
    _animateOutContainer(){
        var rootEl, rootClientRect, navClientRect;

        this.animationInProgress = true;

        rootEl = this.$root[0];
        rootClientRect = rootEl.getBoundingClientRect();
        navClientRect = this.$header[0].getBoundingClientRect();

        rootEl.style['position'] = 'fixed';
        //Add a buffer to top edge so that on resize we dont see a gap between top bar and side nav
        rootEl.style['top'] = '0px';
        rootEl.style['paddingTop'] = navClientRect.height + 'px';
        rootEl.style['right'] = 'auto';
        rootEl.style['left'] = navClientRect.width + 'px';
        rootEl.style['width'] = navClientRect.width + 'px';
        rootEl.style['bottom'] = 0;
        rootEl.style['display'] = 'block';

        //Invert position
        rootEl.style['transform'] = `translate3d(-${rootClientRect.width}px,0,0)`;
        rootEl.style['-webkit-transform'] = `translate3d(-${rootClientRect.width}px,0,0)`;

        //Force sync layout
        rootClientRect = rootEl.getBoundingClientRect();

        return new Promise((resolve, reject) => {
            requestAnimationFrame(() => {

                //Switch on animation
                this.$root.addClass('animate-on-transforms');

                //Play animation
                rootEl.style['transform'] = `translate3d(0,0,0)`;
                rootEl.style['-webkit-transform'] = `translate3d(0,0,0)`;

                setTimeout(()=> {
                    this.$root.removeClass('animate-on-transforms');

                    rootEl.style['display'] = 'none';

                    this.animationInProgress = false;

                    resolve();
                }, this.config.animationDuration)
            });
        });
    }


    /**
     * Show the menu
     */
    open(){
        if(this.animationInProgress){
            return;
        }

        this._showPanel();
    }

    /**
     * Close the menu
     */
    close(){
        if(this.animationInProgress){
            return;
        }
        this._hidePanel();
    }

    /**
     * Show the menu
     */
    toggle(){
        if(this.animationInProgress){
            return;
        }

        if(this.isOpen){
            this.close();
        } else {
            this.open();
        }
    }


    onWindowResize(){
        var navClientRect, rootEl;

        if(!this.isOpen || this.animationInProgress){
            return;
        }

        rootEl = this.$root[0];
        navClientRect = this.$header[0].getBoundingClientRect();

        //If viewport is now in desktop mode, hide the menu
        if(this.config.dismissOnResizeToDesktop && navClientRect.width >= this.config.desktopBreakpoint){
            this._hidePanel();
            return;
        }
        //If viewport is now in desktop mode, hide the menu
        if(this.config.dismissOnResizeToMobile && navClientRect.width < this.config.desktopBreakpoint){
            this._hidePanel();
            return;
        }

        //Add a buffer to top edge so that on resize we dont see a gap between top bar and side nav
        rootEl.style['top'] = (navClientRect.bottom - this.config.menuTopBuffer) + 'px';
        rootEl.style['paddingTop'] = this.config.menuTopBuffer + 'px';
        rootEl.style['right'] = 0;
        rootEl.style['left'] = 'auto';
        rootEl.style['width'] = navClientRect.width + 'px';
        rootEl.style['bottom'] = 0;
    }
}

/**
 *
 * @returns {MobileNavigation}
 */
SidePanel.create = function(){
    return new SidePanel();
};